import { replaceDiacriticsInString } from '@/helpers/replaceDiacriticsInString';

export const searchWithDiacritics = (query, originalArray, fields, subArrayField) => {
  const searchValue = replaceDiacriticsInString(query);

  if (query.length === 0) {
    return originalArray;
  }

  if (subArrayField != null) {
    return originalArray.map((item) => ({
      ...item,
      [subArrayField]: item[subArrayField].filter((subItem) => fields.some((field) => includesIgnoringDiacritics(subItem[field], searchValue))),
    })).filter((item) => item[subArrayField].length > 0);
  }

  return originalArray.filter((item) => fields.some((field) => includesIgnoringDiacritics(item[field], searchValue)));
};

export const includesIgnoringDiacritics = (searchTarget, query) => {
  return replaceDiacriticsInString(searchTarget).includes(replaceDiacriticsInString(query));
};
